export default __webpack_public_path__ + "static/iPad-Mockup3-2642f8ddf4b7d4e42aca29d0fcef7cdc.png";